import React from 'react';
import { Form, Input } from 'antd';
import CommonTemplates from 'app/pages/TemplateManagment/components/FormItems/CommonTemplates';
import classes from './TemplateForm.module.less';

type CriteriaFormProps = {
  readonly?: boolean;

  criteria: {
    name: string;
    value: string;
    configs: any[];
    fields: any[];
  };
};

const CriteriaForm: React.FC<CriteriaFormProps> = ({ criteria, readonly }) => {
  return (
    <Form
      className={classes.criteriaForm}
      layout="vertical"
      initialValues={{ ...criteria }}
    >
      <Form.Item className={classes.sectionName} label="Section Name" name="value">
        <Input disabled={readonly} placeholder="Section Name"></Input>
      </Form.Item>
      {
        // Here we are reusing the CommonTemplates component From Template Management
        // Will Replace or enhance this component with the new one later
      }
      <div className={classes.wrappedControl}>
        <Form.Item name={'fields'} valuePropName="fields" noStyle>
          <CommonTemplates
            sectionName={criteria.name}
            configs={criteria.configs}
            rootName={['fields']}
            readonly={readonly}
          ></CommonTemplates>
        </Form.Item>
      </div>
    </Form>
  );
};

export default CriteriaForm;
